import FormInput from 'components/Input/FormInput';
import React from 'react';

const ArticleField: React.FC = () => {
	return <FormInput testId="ArticleField" name="articleNumber" label="articleNumberLabel" disabled={true} />;
};

export default React.memo(ArticleField);
